import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row, Breadcrumb, Card, Spin, Tooltip, Pagination, Tag } from 'antd';
import { Link } from 'react-router-dom';
import _ from 'lodash';

import { elipsis } from 'shared/utils/StringUtil';
import urlUtil from 'shared/utils/UrlUtil';
import NoData from 'components/NoData';
import { paginationParam, FILTER_TYPE } from 'shared/constant';
import NewFilter from 'components/NewFilter';

import deliveryRoute from '../../route';

import text from './PartnerList.page.translation';
import './PartnerList.style.less';

class PartnerList extends Component {
  constructor(props) {
    super(props);

    const { resetFilter, match } = this.props;
    if (!match.params.page) {
      resetFilter();
    }
  }

  componentDidMount() {
    const { match, filterValue } = this.props;
    if (match.params.page) {
      this.updatePartnerTable(filterValue);
    } else {
      this.updatePartnerTable([]);
    }
  }

  componentDidUpdate(prevProps) {
    const { formControlShow, match, filterValue } = this.props;

    if (prevProps.match.params.page !== match.params.page) {
      this.updatePartnerTable(filterValue);
    }

    if (prevProps.filterValue !== filterValue && !formControlShow) {
      if (
        !(
          prevProps.filterValue.length > 0 &&
          prevProps.filterValue.length > filterValue.length &&
          prevProps.filterValue[prevProps.filterValue.length - 1].inputValue
            .length === 0
        )
      ) {
        if (
          prevProps.match.params.page !== match.params.page ||
          (prevProps.match.params.page === match.params.page &&
            match.params.page > 1)
        ) {
          this._handleChangePage(1);
        } else {
          this.updatePartnerTable(filterValue);
        }
      }
    }
  }

  _renderBreadCrumb = () => {
    const {
      intl: { formatMessage },
    } = this.props;
    return (
      <Row className="breadcrumb-wrapper">
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link to="/">{formatMessage(text.home)}</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>{formatMessage(text.partnerList)}</Breadcrumb.Item>
        </Breadcrumb>
      </Row>
    );
  };

  _handlerGoToDetail = partner => () => {
    const path = deliveryRoute.PARTNER_DETAIL.replace(':id', partner.id);
    this.props.history.push(path);
  };

  _renderCard = partner => (
    <div key={`partner_${partner.id}`}>
      <Card className="card-list">
        <div>
          <Row
            className="card-title"
            onClick={this._handlerGoToDetail(partner)}
          >
            <Tooltip placement="topLeft" title={partner.name}>
              <span>{elipsis(partner.name, 30)}</span>
            </Tooltip>
          </Row>
          <Row className="card-id">{partner.id}</Row>
          <Row className="card-logo">
            <img src={partner.logo} alt="partner-logo" />
          </Row>
        </div>

        <div className="partner-tag">
          {partner.services.slice(0, 3).map(({ name }) => (
            <Tag color="#00ce64">{name}</Tag>
          ))}
          {partner.services.length > 3 && (
            <Tag color="#b8b8b8">{`+ ${partner.services.length - 3} more`}</Tag>
          )}
        </div>
      </Card>
    </div>
  );

  _renderCards = chunk => {
    const { length } = chunk;

    const additionalComp = [];
    let i;
    for (i = 0; i < 4 - length; i += 1) {
      additionalComp.push(
        <div className="card-list" key={`placeholder_${i}`} />,
      );
    }
    return (
      <div className="row-card" key={chunk[0].id}>
        {chunk.map(item => this._renderCard(item))}
        {additionalComp}
      </div>
    );
  };

  _renderListPartner = () => {
    const { partnerList, partnerFilter } = this.props;

    const totalItem = partnerFilter.page_size * partnerFilter.page_count;
    if (partnerList.length) {
      return (
        <div>
          <div
            className="cards-wrapper-t"
            style={{ height: `${265 * Math.ceil(partnerList.length / 4)}px` }}
          >
            <div className="cards-scroll">
              {_.chunk(partnerList, 4).map(this._renderCards)}
            </div>
          </div>
          <div className="pagination">
            <Pagination
              total={totalItem}
              onChange={this._handleChangePage}
              pageSize={12}
              current={partnerFilter.page_num}
            />
          </div>
        </div>
      );
    }

    return <NoData />;
  };

  buildGetParamUrl = filterValue => {
    let result = '';

    filterValue.forEach(element => {
      const value = element.inputValue[0];
      switch (element.key) {
        default:
          result += `&${element.key}=${value}`;
          break;
      }
    });

    return result;
  };

  buildPaginationUrl = transactionsFilter => {
    let result = '';
    result += `page_size=${encodeURIComponent(12)}`;
    result += `&page_count=${encodeURIComponent(
      transactionsFilter.page_count,
    )}`;
    result += `&page_num=${encodeURIComponent(transactionsFilter.page_num)}`;

    return result;
  };

  updatePartnerTable = filterValue => {
    const { getListPartner, partnerFilter, match, history } = this.props;

    let paginationValue = { ...paginationParam };
    let paramUrl = '';
    const page = _.get(match, 'params.page', '');
    const pageInt = parseInt(page, 10) || '';

    if (filterValue.length > 0) {
      paramUrl = this.buildGetParamUrl(filterValue);
    }

    if (page) {
      if (pageInt && pageInt >= 1) {
        paginationValue = {
          ...partnerFilter,
          page_num: pageInt,
        };
        const paginationUrl = this.buildPaginationUrl(paginationValue);
        getListPartner(paginationUrl, paramUrl);
      } else {
        history.push(deliveryRoute.PARTNER_LIST);
      }
    } else {
      const paginationUrl = this.buildPaginationUrl(paginationValue);
      getListPartner(paginationUrl, paramUrl);
    }
  };

  _handleChangePage = page => {
    urlUtil.changePageParams(
      deliveryRoute.PARTNER_LIST,
      page,
      this.props.history,
    );
  };

  render() {
    const {
      intl: { formatMessage },
      loading,
    } = this.props;

    const options = [
      {
        label: formatMessage(text.filter.name),
        value: 'logistic_partner_name',
        type: FILTER_TYPE.TEXT,
      },
      {
        label: formatMessage(text.filter.service),
        value: 'service_name',
        type: FILTER_TYPE.TEXT,
      },
      {
        label: formatMessage(text.filter.tag),
        value: 'service_tag',
        type: FILTER_TYPE.TEXT,
      },
    ];
    return (
      <div className="main-content">
        {this._renderBreadCrumb()}
        <div className="white-box-wrapper partner-management">
          <span className="title mbottom30">
            {formatMessage(text.partnerList)}
          </span>

          <NewFilter options={options} />
          <Row>
            <Spin spinning={loading}>{this._renderListPartner()}</Spin>
          </Row>
        </div>
      </div>
    );
  }
}

PartnerList.propTypes = {
  intl: PropTypes.object,
  partnerList: PropTypes.arrayOf(PropTypes.object),
  partnerFilter: PropTypes.object,
  loading: PropTypes.bool,
  resetFilter: PropTypes.func,
  filterValue: PropTypes.array,
  history: PropTypes.object,
  match: PropTypes.object,
  formControlShow: PropTypes.bool,
  getListPartner: PropTypes.func,
};

export default PartnerList;
